import { useSearchIndex } from './use-search-index.hook';
import { SearchIndexEnum } from '@vivli/features/search/infrastructure/enum';

export const useStudiesSearch = () => {
    return useSearchIndex({
        index: SearchIndexEnum.Studies
    });
};
